import { LinkProduct } from "../../types/linkProduct";
import { SupplierBaseProduct } from "../../types/supplierBaseProduct";

export const getCategories = (product: SupplierBaseProduct, linkProducts: LinkProduct[]): string[] => {
    if(!product.linkProductId) return product.categories;
    const linkProduct = linkProducts.find(linkProduct => linkProduct.id === product.linkProductId);
    if(linkProduct) return linkProduct.categories;
    return [];
    
}